<template>
  <el-menu
    v-if="user"
    :default-active="navIndex"
    class="el-menu-vertical-demo menu-nav"
    :class="{ 'position-t-0': navTop < 0 }"
    :style="`top:${navTop}px`"
    :collapse="true"
    background-color="#04094C"
    text-color="#ffffff"
    active-text-color="#ffffff"
  >
    <!-- background-color="#0065B3" -->

    <el-menu-item>
      <div @click="gotoPage('/')">
        <i class="fas fa-home"></i>
      </div>
      <span slot="title">หน้าหลัก</span>
    </el-menu-item>

    <el-menu-item v-if="user.role == 50" index="1">
      <div @click="gotoPage('/manage/course/instructor')">
        <i class="fas fa-calendar-alt"></i>
      </div>
      <span slot="title">จัดการหลักสูตร</span>
    </el-menu-item>

    <el-menu-item v-if="user.role == 80 || user.role == 60" index="1">
      <div @click="gotoPage('/manage/course/list')">
        <i class="fas fa-calendar-alt"></i>
      </div>
      <span slot="title">จัดการหลักสูตร</span>
    </el-menu-item>

    <el-menu-item v-if="user.role == 80" index="9">
      <div @click="gotoPage('/admin/list')">
        <i class="fas fa-user-friends"></i>
      </div>
      <span slot="title">จัดการรายชื่อผู้ดูแลระบบ</span>
    </el-menu-item>

    <el-menu-item v-if="user.role == 80 || user.role == 60" index="2">
      <div @click="gotoPage('/instructor/list')">
        <i class="fas fa-user-friends"></i>
      </div>
      <span slot="title">จัดการรายชื่อผู้สอน</span>
    </el-menu-item>

    <el-menu-item v-if="user.role == 80 || user.role == 60" index="3">
      <div @click="gotoPage('/name/list')">
        <i class="fas fa-users"></i>
      </div>
      <span slot="title">จัดการรายชื่อผู้เรียน</span>
    </el-menu-item>

    <el-menu-item
      v-if="user.role == 80 || user.role == 60 || user.role == 50"
      index="4"
    >
      <div @click="gotoPage('/manage/activity/score')">
        <i class="far fa-file"></i>
      </div>
      <span slot="title">จัดการคะแนนหลักสูตร</span>
    </el-menu-item>

    <el-menu-item
      v-if="user.role == 80 || user.role == 60 || user.role == 50"
      index="5"
    >
      <div @click="gotoPage('/summary/name/list')">
        <i class="far fa-copy"></i>
      </div>
      <span slot="title">สรุปรายชื่อผู้เรียนหลักสูตร</span>
    </el-menu-item>

    <el-menu-item v-if="user.role == 80 || user.role == 60" index="6">
      <div @click="gotoPage('/feedback/name/list')">
        <i class="far fa-calendar-check"></i>
      </div>
      <span slot="title">ผลการประเมินหลักสูตร</span>
    </el-menu-item>

    <el-menu-item v-if="user.role == 80 || user.role == 60" index="7">
      <div @click="gotoPage('/dashboard')">
        <i class="fas fa-chart-line"></i>
      </div>
      <span slot="title">ข้อมูลสรุปของหลักสูตร</span>
    </el-menu-item>

    <el-menu-item
      v-if="user.role == 80 || user.role == 60"
      index="8"
      class="menu-bottom"
    >
      <div @click="gotoPage('/manage/general')">
        <i class="fas fa-cog"></i>
      </div>
      <span slot="title">จัดการข้อมูลทั่วไป</span>
    </el-menu-item>

    <!-- <el-submenu v-if="user.role == 80 || user.role == 60" index="9" class="menu-bottom">
      <template slot="title">
        <i class="fas fa-cog"></i>
      </template>
      <el-menu-item-group>
        <span slot="title">จัดการข้อมูลทั่วไป</span>
        <el-menu-item index="7"
          ><div @click="gotoPage('/summary/activity/list')">
            จัดการภาพแบนเนอร์หน้าเริ่มต้น
          </div></el-menu-item
        >
        <el-menu-item index="7"
          ><div @click="gotoPage('/manage/activity/score')">
            จัดการใบประกาศนียบัตร
          </div></el-menu-item
        >
      </el-menu-item-group>
    </el-submenu> -->

    <el-menu-item v-if="user.role == 0" index="1">
      <div @click="gotoPage('/my/course?tab=1')">
        <i class="fas fa-calendar-alt"></i>
      </div>
      <span slot="title">หลักสูตรของฉัน</span>
    </el-menu-item>
    <el-menu-item v-if="user.role == 0" index="2">
      <div @click="gotoPage('/course/score')">
        <i class="far fa-file-alt"></i>
      </div>
      <span slot="title">ผลการคะแนนการเรียนแต่ละหลักสูตร</span>
    </el-menu-item>
    <el-menu-item v-if="user.role == 0" index="3">
      <div @click="gotoPage('/certificate')">
        <i class="far fa-file"></i>
      </div>
      <span slot="title">ประกาศนียบัตรรับรองการจบหลักสูตร</span>
    </el-menu-item>
    <el-menu-item v-if="user.role == 0" index="4">
      <div @click="gotoPage('/notification')">
        <i class="far fa-bell"></i>
      </div>
      <span slot="title">การแจ้งเตือนทั้งหมด</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  data() {
    return {
      navIndex: "",
      navTop: 60,
    };
  },
  created() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted() {
    if (typeof this.$route.meta != "undefined") {
      this.navIndex =
        this.user.role > 0 && this.$route.name == "notification"
          ? ""
          : this.$route.meta.menuIndex;
    }
  },
  methods: {
    gotoPage(path) {
      this.$router.push(path).catch(() => {});
    },
    handleScroll(event) {
      var elmnt = document.getElementsByTagName("html");
      this.navTop = 60 - elmnt[0].scrollTop;
    },
  },
};
</script>

<style scoped>
.menu-bottom {
  position: fixed;
  bottom: 0;
  width: 64px;
}
.menu-nav {
  position: fixed;
}
</style>
